import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "This study requires the browser zoom to be set to 100%", "Screenout", "User failed zoom check", "app.error.zoom")